<p-panel
  [collapsed]="isCollapsed()"
  (collapsedChange)="onCollapsedChange($event)"
  [toggleable]="true"
  iconPos="start"
  toggler="header"
  [style]="{
    '--p-panel-toggleable-header-padding': '0',
    '--p-panel-content-padding': '0',
  }">
  <ng-template pTemplate="header">
    <div class="tw:w-full tw:flex tw:items-center tw:gap-2">
      <div
        class="tw:flex tw:shrink-0 tw:items-center tw:justify-center tw:rounded-lg tw:p-1"
        [pTooltip]="OBJECT_DISPLAY_NAMES[diffData().object]"
        [ngStyle]="diffData().object | objectIconPipe">
        <i
          [class]="OBJECT_INFO[diffData().object]?.icon"
          [ngStyle]="{
            color: OBJECT_INFO[diffData().object]?.color ?? 'var(--p-primary-700)',
          }"
          style="font-size: 1rem"></i>
      </div>
      <span>{{ diffData().name }}</span>
    </div>
    <!-- Diff stats - GitHub style -->
    <div class="tw:ms-auto tw:flex tw:items-center tw:gap-2 tw:px-2">
      <div class="tw:flex tw:gap-1 tw:items-center">
        @if (diffData().additions > 0) {
          <p-message
            severity="success"
            variant="simple"
            [motionOptions]="{ disabled: true }">
            +{{ diffData().additions }}
          </p-message>
        }
        @if (diffData().deletions > 0) {
          <p-message
            severity="error"
            variant="simple"
            [motionOptions]="{ disabled: true }">
            -{{ diffData().deletions }}
          </p-message>
        }
        @for (square of diffSquares(); track $index) {
          <div
            class="tw:w-3 tw:h-3 tw:rounded"
            [ngClass]="{
              'tw:bg-green-600': square === 'addition',
              'tw:bg-red-600': square === 'deletion',
              'tw:bg-surface-200': square !== 'addition' && square !== 'deletion',
            }"></div>
        }
      </div>
    </div>
  </ng-template>

  @if (!isCollapsed()) {
    @if (isLoading()) {
      <div class="tw:p-3">
        <cor-skeleton [type]="SKELETON_TYPES.LIST" />
      </div>
    } @else if (errorMessage()) {
      <div class="tw:p-3">
        <p-message severity="error">{{ errorMessage() }}</p-message>
      </div>
    } @else if (detail()) {
      <div class="tw:flex tw:flex-col tw:gap-2">
        @let oldData = detail().old;
        @let newData = detail().new;

        @if (oldData?.promptTemplate || newData?.promptTemplate) {
          <cor-diff-viewer
            [leftValue]="oldData?.promptTemplate"
            [rightValue]="newData?.promptTemplate"
            leftTitle="Prompt Template"
            maxHeight=""
            language="plaintext" />
        }
        @if (oldData?.definition || newData?.definition) {
          <cor-diff-viewer
            [leftValue]="oldData?.definition"
            [rightValue]="newData?.definition"
            [leftTitle]="
              diffData().object === OBJECTS.PROMPT ? 'Prompt Creation Logic' : 'Original'
            "
            maxHeight=""
            language="python" />
        }
      </div>
    }
  }
</p-panel>
